<div class="agent_loader" *ngIf="isloading">
    <div class="loader"></div>
</div>
<div class="d-page-scroll project-list">
    <main class="list-va-wrap">
        <div class="project-head">


            <ng-template #startTourContent let-c="close">
                <div class="tour-start-modal">
                    <div class="modal-body">
                        <div class="text-wel-wrap">
                            <h4 class="modal-title"><img class="logo-main" src="assets/images/logo-main.svg" alt="logo" />
                            </h4>
                            <h5 class="welcome-text">Welcome {{_userService?.currentUser?.first_name + " " + _userService?.currentUser?.last_name}}
                            </h5>
                            <p class="wel-content">Start now with a single click and make it easy for you to work on CIRA. Skip tutorials if you are familiar with our platform</p>
                        </div>

                        <div class="img-wel-wrap">
                            <img class="tour-guide" src="assets/images/tour-guide-illustration.svg" alt="logo" align="right" />
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-close" (click)="c('Close click')">Skip
                            Tutorial</button>
                        <button class="btn btn-green" (click)="openSelectGuide(selectGuideContent);c('Close click')">Let's get started</button>
                    </div>
                </div>
            </ng-template>

            <ng-template #selectGuideContent let-c="close" let-d="dismiss">
                <div class="select-type-tour">
                    <div class="modal-header">
                        <h4 class="modal-title">Select Guide Type</h4>
                        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">

                        <p>We have two kinds of guide, one is step by step Product tours(Tour Guide) and another one is Product documentation(Help Doc).</p>
                        <img class="tour-guide" src="assets/images/select-guide.svg" alt="logo" />
                    </div>
                    <div class="modal-footer">
                        <button class="btn" (click)="openTourPopUp();c('Close click')"><i class="iconB-guide-tour"></i>Tour
                            Guide</button>
                        <button class="btn" (click)="gotoHelps()"><i class="iconB-doc"></i>Help Doc</button>
                    </div>
                </div>
            </ng-template>


            <div class="head-icon-wrap">
                <h2 class="title">My Copilots</h2>
                <!-- <span class="help-icon-assist"><i class="icon-help"></i></span> -->
            </div>
            <div class="info">
                <button class="p-0 bg-transparent border-0" (click)="showNotification = false">
                    <app-cira-help></app-cira-help>
                </button>
                <div>
                    <span class="noti-wrap" tabindex="2">
                        <a class="btn-not" href="javascript:void(0)" (click)="toggleNotification()" placement="top">
                            <i class="iconB-notification"></i>
                            <span *ngIf="notificationCount>0" class="badge">{{notificationCount}}</span>
                        </a>
                        <div class="loader" [ngStyle]="{'display':notificationStatus  ? 'block' : 'none' }">
                            <div class="notification-loader"></div>
                        </div>
                        <app-notifications [showNotification]="showNotification" (notificationCount)="notificationCountUpdated($event)" id="notificationContainer" [style.display]="showNotification ?  'block' : 'none'"></app-notifications>
                    </span>
                </div>


                <div ngbDropdown class="user" tabindex="4">
                    <button class="btn" id="profilinfo" ngbDropdownToggle (click)="showNotification = false">

                        <img [src]="profile_pic" alt="">
                    </button>

                    <div ngbDropdownMenu aria-labelledby="profileinfo">
                        <div class="pointer"></div>
                        <div class="img-wrapper">
                            <div class="profile-img-wrap">
                                <img class="profile-img" [src]="(profile_pic) ? profile_pic : 'assets/images/profile-default.svg'">

                            </div>
                            <p class="profile-user">
                                {{_userService?.currentUser?.first_name + " " + _userService?.currentUser?.last_name}}
                            </p>
                            <p class="profile-user role">{{_userService?.currentUser?.description | limitTo : 12}}</p>

                        </div>

                        <button class="dropdown-item" routerLink="/user-profile"><span
                                class="profile-icon iconB-settings-filled"></span>Profile settings<i
                                ngbTooltip="MFA is disabled" class="warning-icon icon-topic-warnning"
                                *ngIf="!_userService?.currentUser?.mfa_enable"><span
                                    class="warn-bg"></span></i></button>
                        <button class="dropdown-item" routerLink="/logout"><span
                                class="profile-icon iconB-logout"></span>Logout</button>
                        <div class="theme-button">
                            <span class="toggle-text">Light</span>
                            <label class="switch">
                                <input type="checkbox" [(ngModel)]="theme" (change)="changeColorTheme($event)">
                                    <span class="slider round"></span>
                                </label>
                            <span class="toggle-text">Dark</span>
                        </div>
                    </div>
                </div>

            </div>

        </div>


        <div class="form-filter-wrap">
            <div class="form-group">
                <div class="icon-addon">
                    <input type="text" placeholder="Search for Copilots and Clients" class="form-control c-form-control c-icon-control" [(ngModel)]="searchText" (ngModelChange)="searchInputChanged()" />
                    <button class="btn"><i class="icon icon-search-new c-form-control-icon" *ngIf="!searchText"></i></button>
                    <span class="icon-cira clear-text" (click)="searchText = ''; searchInputChanged()" *ngIf="searchText"></span>
                </div>
            </div>
            <div class="form-filter">
                <div class="col-filter filter-show">
                    <span class="filter-title" (click)="showFiter=!showFiter"><i class="iconB-filter"></i>Filter
                        by</span>
                    <button *ngIf="filtered" (click)="resetClick()"><i class="icon icon-cira"></i>Reset all</button>
                </div>
                <div class="col-filter" [hidden]="showFiter" [ngClass]="{'not-used': filterOwnership == ''}">
                    <span>Ownership</span>
                    <div class="form-select">
                        <i class="icon-angle-down c-dropdown-icon"></i>
                        <select class="c-dropdown c-icon-control" [(ngModel)]="filterOwnership" (ngModelChange)="filterChange()">
                            <option *ngFor="let item of ownershipFilter" value="{{item.value}}">{{item.text}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-filter" [hidden]="showFiter" [ngClass]="{'not-used': filterStates == ''}">
                    <span>State</span>
                    <div class="form-select">
                        <i class="icon-angle-down c-dropdown-icon"></i>
                        <select class="c-dropdown c-icon-control" [(ngModel)]="filterStates" (ngModelChange)="filterChange()">
                            <option *ngFor="let item of statesFilter" value="{{item.value}}">{{item.text}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-filter" [hidden]="showFiter" [ngClass]="{'not-used': filterRoles == ''}">
                    <span>User role</span>
                    <div class="form-select">
                        <i class="icon-angle-down c-dropdown-icon"></i>
                        <select class="c-dropdown c-icon-control" [(ngModel)]="filterRoles" (ngModelChange)="filterChange()" [disabled]="(filterOwnership=='owned_by_me'||filterOwnership=='shared_by_me')">
                            <option *ngFor="let item of rolesFilter" value="{{item.value}}">{{item.text}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-filter" [hidden]="showFiter" [ngClass]="{'not-used': filterTypes == ''}">
                    <span>Bot Type</span>
                    <div class="form-select">
                        <i class="icon-angle-down c-dropdown-icon"></i>
                        <select class="c-dropdown c-icon-control" [(ngModel)]="filterTypes" (ngModelChange)="filterChange()">
                            <option *ngFor="let item of botTypeFilter" value="{{item.value}}">{{item.text}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <section class="va-wrapper" *ngIf="!filtered">
            <!-- card list -->
            <div class="card-list" *ngIf="pinnedProjects[0]">
                <h3 class="topic-title">Pinned</h3>
                <div class="row">
                    <div *ngFor="let pinnedItem of pinnedProjects[0]">
                        <app-virtual-assistant-card *ngIf="!pinnedItem.archive" [vaAgent]=pinnedItem (userPinned)="getPinnedItem($event)">
                        </app-virtual-assistant-card>
                        <!-- [isSmallCard]="true" -->
                    </div>
                </div>
            </div>
            <div class="card-list" *ngFor="let sectorGroup of groupedProjects">
                <h3 class="topic-title">{{sectorGroup.sector}}</h3>
                <div class="row">
                    <div *ngFor="let project of sectorGroup.projects">
                        <app-virtual-assistant-card *ngIf="!project.archive" [vaAgent]=project (userPinned)="getPinnedItem($event)">
                        </app-virtual-assistant-card>
                        <!-- [isSmallCard]="true" -->
                    </div>
                </div>
            </div>

            <div *ngIf="recentlyCreatedProjects.length == 0 && groupedProjects.length == 0 && pinnedProjects.length==0" class="card-list no-project">
                <p>No project found</p>
            </div>

        </section>

        <section class="va-wrapper" *ngIf="filtered">
            <!-- card list -->
            <div class="card-list">
                <h3 class="topic-title">Filtered</h3>
                <div class="row">
                    <div class="col" *ngFor="let project of filteredProjectsList">
                        <app-virtual-assistant-card [vaAgent]=project (userPinned)="getPinnedItem($event)">
                        </app-virtual-assistant-card>
                    </div>
                </div>
            </div>

            <div *ngIf="filteredProjectsList.length == 0" class="card-list no-project">
                <p>No project found</p>
            </div>
        </section>

        <section class="va-wrapper" *ngIf="_userService.currentUser.library_admin">
            <div class="card-list">
                <div class="head-wrap d-flex align-items-center" (click)="openPackageLibrary = !openPackageLibrary;">
                    <h3 class="topic-title">Package Library</h3>
                    <button ><i class="icon " [ngClass]="openPackageLibrary ? 'icon-angle-up' : 'icon-angle-down'"></i></button>
                </div>
                <div class="row" *ngIf="openPackageLibrary">
                    <div class="col" *ngFor="let project of packageLibraryList">
                        <app-virtual-assistant-card [vaAgent]=project [packageLibrary]=openPackageLibrary (userPinned)="getPinnedItem($event)">
                        </app-virtual-assistant-card>
                    </div>
                </div>
            </div>

            <div *ngIf="packageLibraryList.length == 0 && openPackageLibrary" class="card-list no-project">
                <p>No project found</p>
            </div>
        </section>

        <div class="create-va-new">
            <button class="btn create-btn" (click)="createNewProject(addNewProject);newProjectFlag=true"><i class="icon icon-plus-new"  tourAnchor="new-project"></i></button>
        </div>
    </main>
</div>



<ng-template #addNewProject let-c="close" let-d="dismiss">
    <div class="modal-form">
        <div class="creat-pophead">
            <h5>Basic Info</h5>
            <div class="form-group create-tab">
                <div class="radio" [ngClass]="{'active-tab': createRadio}">
                    <input id="radio-1" class="form-check-radio" type="radio" name="mode" [value]="true" [(ngModel)]="createRadio">
                    <label for="radio-1" class="radio-label">Create New</label>
                </div>
                <div class="radio" [ngClass]="{'active-tab': !createRadio}">
                    <input id="radio-2" class="form-check-radio" type="radio" name="mode" [value]="false" [(ngModel)]="createRadio">
                    <label for="radio-2" class="radio-label">Import Project</label>
                </div>
            </div>
        </div>
        <form [formGroup]="newProjectForm" *ngIf="createRadio">
            <div class="modal-body create-va-popup">
                <div class="form-group" tourAnchor="project-title">
                    <label>Project Title<span>*</span></label>
                    <input type="text" class="c-form-control" formControlName="title" id="projectInput" autocomplete="off" required="">
                    <form-validation-message [control]="newProjectForm.controls.title"></form-validation-message>
                </div>
                <div class="form-group" tourAnchor="project-description">
                    <label>Description<span>*</span></label>
                    <textarea type="text" class="c-form-control description-content" formControlName="description" id="descriptionInput" autocomplete="off" required=""></textarea>
                    <form-validation-message [control]="newProjectForm.controls.description"></form-validation-message>
                </div>
                <div class="form-group" tourAnchor="client-name">
                    <label>Client Name<span>*</span></label>
                    <input type="text" class="c-form-control" formControlName="client_name" id="clientInput" autocomplete="off" required="">
                    <form-validation-message [control]="newProjectForm.controls.client_name"></form-validation-message>
                </div>
                <div class="form-group" tourAnchor="language-selection">
                    <label>Language<span>*</span></label>
                    <div class="form-group">
                        <i class="icon-angle-down c-dropdown-icon"></i>
                        <select class="c-dropdown c-icon-control" formControlName="language">
                            <option *ngFor="let item of languages" value="{{item.value}}">{{item.text}}</option>
                        </select>
                    </div>
                    <form-validation-message [control]="newProjectForm.controls.language"></form-validation-message>
                </div>
                <div class="form-group" tourAnchor="project-selection">
                    <label>Project Type<span>*</span></label>
                    <div class="form-group">
                        <i class="icon-angle-down c-dropdown-icon"></i>
                        <select class="c-dropdown c-icon-control" formControlName="project_type">
                            <option *ngFor="let item of projectTypes" value="{{item.value}}">{{item.text}}</option>
                        </select>
                    </div>
                    <form-validation-message [control]="newProjectForm.controls.project_type"></form-validation-message>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-close" (click)="c('Close click')">Cancel</button>
                <button class="btn btn-green" (click)="onCreate()" tourAnchor="proceed-project">Proceed</button>
            </div>
        </form>
        <form [formGroup]="existingProjectForm" *ngIf="!createRadio">
            <div class="modal-body create-va-popup">
                <div class="form-group">
                    <label>Project Title<span>*</span></label>
                    <input type="text" class="c-form-control" formControlName="title" id="projectInput" autocomplete="off" required="">
                    <form-validation-message [control]="existingProjectForm.controls.title"></form-validation-message>
                </div>
                <div class="form-group">
                    <label>Description<span>*</span></label>
                    <textarea type="text" class="c-form-control description-content" formControlName="description" id="descriptionInput" autocomplete="off" required=""></textarea>
                    <form-validation-message [control]="existingProjectForm.controls.description">
                    </form-validation-message>
                </div>
                <div class="form-group" >
                    <label>Client Name<span>*</span></label>
                    <input type="text" class="c-form-control" formControlName="client_name" id="clientInput" autocomplete="off" required="">
                    <form-validation-message [control]="existingProjectForm.controls.client_name"></form-validation-message>
                </div>
                <div class="form-group">
                    <label>Upload file<span>*</span></label>
                    <div class="fileUpload btn btn-primary">
                        <span>Upload</span>
                        <input #uploadedFile type="file" class="form-control upload" id="fileInput" autocomplete="off" required="" (change)="uploadFile(uploadedFile)" accept=".zip">
                    </div>
                    <span class="msg"> {{loadedFile?.name}} </span> {{sizeErrorMsg}}
                    <span *ngIf="!sizeErrorMsg" class="err msg">{{sizeErrorMsg}}</span>
                    <!-- <span class="err-msg msg" *ngIf="uploadedFile.files.length == 1">File not supported</span> -->

                    <!-- <span [control]="existingProjectForm.controls.upload_file"></form-validation-message> -->
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-close" (click)="c('Close click');loadedFile=''; fileStatus=false">Cancel</button>
                <button class="btn btn-green" [disabled]="!existingProjectForm.valid || fileuploading || !fileStatus" (click)="createExisting(uploadedFile)">Proceed
                    <img *ngIf="fileuploading"
                        src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                </button>
            </div>
        </form>
    </div>
</ng-template>
<app-tour-search [restrict]="true"></app-tour-search>
<tour-step-template *ngIf="tourGuideService.currentTour=='Create new project'">
    <ng-template let-step="step">
        <p class="tour-step-content" [innerHTML]='step?.content'></p>
        <div class="tour-step-navigation">
            <button *ngIf="tourService.hasPrev(step)" class="btn btn-sm btn-default" (click)="tourService.prev()">< {{step?.prevBtnTitle}}</button>
            <button class="nxt-btn" *ngIf="tourService.hasNext(step)" [disabled]="(step.anchorId === 'new-project' && newProjectFlag===false)" (click)="tourService.next()">{{step?.nextBtnTitle}} {{tourService.steps.indexOf(tourService.currentStep)+1}}/{{tourService.steps?.length}}</button>
            <button class="btn btn-sm btn-default" (click)="tourService.end()">{{tourService.hasNext(step)?'Skip':'End'}}</button>
        </div>
    </ng-template>
</tour-step-template>